import React, { useCallback, useContext, useEffect, useState } from 'react';

import "./styles.scss"
import { AppContext } from '../../contexts/AppContext';
import Copyright from '../../components/Copyright';

const WelcomePage = () => {
    const { user } = useContext(AppContext)

    return (
        <div className="welcome-page">
            <div className="inner">
                <h2>Olá, {user.fullName?.split(" ")?.[0]}!</h2>
            </div>

            <Copyright />
        </div>
    )
};

export default WelcomePage;
